//@flow
import React, { Component } from "react";
import "./add-wishlist-to-cart.scss";
import { addWishlistToCart } from "../services/add-to-cart";

import { notify } from "../services/notification";

import type { ProductType } from "../types/product";
import type { ProductPurchasability } from "../types/publicpurchasable";

type Props = {
  className: string,
  products: ProductType[],
  isPostCodeAvailable: boolean,
  isLoadingPurchasability: boolean,
  productPurchasabilityMap: Map<number, ProductPurchasability>
};
type State = {
  btnText: string
};

const textProductAdded = "PRODUCT(S) ADDED";
const textAddingProducts = "ADDING";
const textAddToWishlist = "ADD WISHLIST TO CART";

class AddWishlistToCart extends Component<Props, State> {
  constructor() {
    super();
    this.state = {
      btnText: textAddToWishlist
    };
  }

  handleClick = async () => {
    this.setState({ btnText: textAddingProducts });

    try {
      let products = this.props.products.filter(
        p =>
          this.props.productPurchasabilityMap &&
          this.props.productPurchasabilityMap.get(p.productCode) === "Add"
      );
      await addWishlistToCart(products);
      this.setState({ btnText: textProductAdded });

      window.setTimeout(() => {
        this.setState({ btnText: textAddToWishlist });
      }, 1000);

      if (
        this.props.products.some(
          p =>
            this.props.productPurchasabilityMap &&
            this.props.productPurchasabilityMap.get(p.productCode) ===
              "IN_STORE_ONLY"
        )
      ) {
        notify({
          level: "SUCCESS",
          title: "Notice",
          text: "In-store only products are unable to be added to cart"
        });
      }
      if (
        this.props.products.some(
          p =>
            this.props.productPurchasabilityMap &&
            this.props.productPurchasabilityMap.get(p.productCode) ===
              "Check Availability (Creative Glass)"
        )
      ) {
        notify({
          level: "SUCCESS",
          title: "Notice",
          text: "Creative Glass products are unable to be added to cart"
        });
      }
    } catch (_) {
      this.setState({ btnText: textAddToWishlist });
      notify({
        level: "ERROR",
        title: "Failed",
        text: "Error occurred while submitting the wishlist to order"
      });
    }
  };

  render() {
    const isDisabled =
      this.props.products.every(
        product =>
          this.props.productPurchasabilityMap &&
          (this.props.productPurchasabilityMap.get(product.productCode) ===
            "IN_STORE_ONLY" ||
            this.props.productPurchasabilityMap.get(product.productCode) ===
              "Check Availability (Creative Glass)")
      ) ||
      !this.props.isPostCodeAvailable ||
      this.props.isLoadingPurchasability;

    return (
      <button
        disabled={isDisabled ? "disabled" : null}
        className={this.props.className}
        onClick={this.handleClick}
      >
        {this.state.btnText}
      </button>
    );
  }
}

export default AddWishlistToCart;
